import { rootApi } from "..";
import { reimbursementService } from "../../../Api/Services/ImbursementService";
import { makeEndpoints } from "../../../utils/rtkQueryFactory";

const reimbursementEndpoints = [
  {
    name: "reimbursementList",
    type: "query",
    serviceFn: (userId?: number) =>
      reimbursementService.reimbursementList(userId),
    tagType: "ReimbursementInfo",
  },
  {
    name: "reimbursementCategoryList",
    type: "query",
    serviceFn: () => reimbursementService.reimbursementCategoryList(),
  },
  {
    name: "submitReimbursementForm",
    type: "mutation",
    serviceFn: (reimbursementForm: FormData) =>
      reimbursementService.submitReimbursementForm(reimbursementForm),
    tagType: "ReimbursementInfo",
  },
  {
    name: "deleteReimbursementDetail",
    type: "mutation",
    serviceFn: (deleteReimbursementId: { id: number }) =>
      reimbursementService.deleteReImbursement(deleteReimbursementId),
    tagType: "ReimbursementInfo",
  },
] as const;

export const reimbursementEndpointsApi = rootApi.injectEndpoints({
  endpoints: (builder) => makeEndpoints(builder, reimbursementEndpoints),
});

export const {
  useReimbursementListQuery,
  useReimbursementCategoryListQuery,
  useSubmitReimbursementFormMutation,
  useDeleteReimbursementDetailMutation,
} = reimbursementEndpointsApi;
